import { AppBar, Toolbar, Box, IconButton, Typography, MenuItem, Menu, Drawer, Button, TextField } from '@mui/material';
import { useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Link, useForm, usePage } from '@inertiajs/react';
import Logo from './Logo';
import { PageProps } from '@inertiajs/core';
import EditIcon from '@mui/icons-material/Edit';
interface User extends PageProps {
  user: {
    id: number;
    name: string;
    email: string;
    facility_name: string;
    facility_location: string;
    role: string;
  }
}

export default function Header() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [anchorElSupport, setAnchorElSupport] = useState<null | Element>(null);
  const [reportBugOpen, setReportBugOpen] = useState(false);
  const { user } = usePage<User>().props;

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setAnchorElUser(event.currentTarget);
  };
  const handleOpenSupportMenu = (event: React.MouseEvent<Element, MouseEvent>) => {
    event.preventDefault();
    setAnchorElSupport(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCloseSupportMenu = () => {
    setAnchorElSupport(null);
  };

  const logout = () => {
    fetch('/logout', { method: 'POST',headers: { 'Content-Type': 'application/json' }}).then(() => {
      window.location.href = '/login';
    });
  }

  return (
    <>
      <AppBar position="fixed" sx={{ bgcolor: '#0E132E' }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link href="/" style={{ textDecoration: 'none', marginLeft: '3px', marginRight: '48px', color: 'inherit', display: 'flex', alignItems: 'center' }}>
            <Logo width={128.77} height={40} />
          </Link>
          <Box sx={{display: { mobile: 'none', desktop: 'flex' }, alignItems: 'center', flexGrow: 1, gap: 3}}>
            <Link href="/" style={{ textDecoration: 'none', color: 'inherit', marginRight: 2 }}>
              <Typography variant="body1">Matching Tool</Typography>
            </Link>
            {/* <Link href="/history" style={{ textDecoration: 'none', color: 'inherit' }}>
              <Typography variant="body1">History Log</Typography>
            </Link> */}
          </Box>
          <Box sx={{ display:{ mobile: 'none', desktop: 'flex' }, alignItems: 'center', gap: 3}}>
            <Link href="#" onClick={handleOpenSupportMenu} style={{ textDecoration: 'none', color: 'inherit' }}>
              <Typography sx={{ display: 'flex', gap: 1 }} variant="body1">Support <ExpandMoreIcon /></Typography>
            </Link>
            <Menu
              id="menu-support"
              open={Boolean(anchorElSupport)}
              onClose={handleCloseSupportMenu}
              anchorEl={anchorElSupport}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <Link href="/support" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem key={'support'} onClick={handleCloseSupportMenu}>
                    <Typography sx={{ textAlign: 'center' }}>Get help</Typography>
                </MenuItem>
              </Link>
              <MenuItem key={'report_bug'} onClick={() => setReportBugOpen(true)}>
                <Typography sx={{ textAlign: 'center' }}>Report a bug</Typography>
              </MenuItem>
            </Menu>
            <IconButton color="inherit" onClick={handleOpenUserMenu}>
              <AccountCircleIcon fontSize="large" />
            </IconButton>
            <Menu 
              id="menu-user"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              >
              <MenuItem key={'view_profile'} onClick={handleCloseUserMenu}>
                <Typography onClick={() => setDrawerOpen(true)} sx={{ textAlign: 'center' }}>View Profile</Typography>
              </MenuItem>
              {user.role !== 'practitioner' && <Link href="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem key={'admin_portal'} onClick={handleCloseUserMenu}>
                  <Typography sx={{ textAlign: 'center' }}>Admin Portal</Typography>
                  </MenuItem>
                </Link>}
              <MenuItem key={'logout'} onClick={logout}>
                <Typography sx={{ textAlign: 'center' }}>Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
          <Box sx={{display: { mobile: 'flex', desktop: 'none' } }}>
            <IconButton
              size="large"
              aria-label="nav bar menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              >
              <MenuIcon />
            </IconButton>
            <Menu 
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
              >
              <Link href="/" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem key={'matching_tool'} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: 'center' }}>Matching Tool</Typography>
                </MenuItem>
              </Link>
              {/* <Link href="/history" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem key={'history_log'} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: 'center' }}>History Log</Typography>
                </MenuItem>
              </Link> */}
              <Link href="/support" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem key={'get_help'} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: 'center' }}>Get help</Typography>
                </MenuItem>
              </Link>
              <MenuItem key={'report_bug'} onClick={() => setReportBugOpen(true)}>
                <Typography sx={{ textAlign: 'center' }}>Report a bug</Typography>
              </MenuItem>
              <MenuItem key={'view_profile'} onClick={handleCloseNavMenu}>
                <Typography onClick={() => setDrawerOpen(true)} sx={{ textAlign: 'center' }}>
                  View Profile
                </Typography>
              </MenuItem>
              {user.role !== 'practitioner' && <Link href="/admin" style={{ textDecoration: 'none', color: 'inherit' }}>
                <MenuItem key={'admin_portal'} onClick={handleCloseNavMenu}>
                  <Typography sx={{ textAlign: 'center' }}>Admin Portal</Typography>
                </MenuItem>
              </Link>}
              <MenuItem key={'logout'} onClick={logout}>
                <Typography sx={{ textAlign: 'center' }}>Logout</Typography>
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <UserProfile open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </>
    );
  }
  
function UserProfile({ open, onClose }: { open: boolean, onClose: () => void }) {
  const { user } = usePage<User>().props;
  const { id, name, email, facility_name, facility_location, role } = user;
  const { data, setData, put, errors } = useForm({ name: user.name });
  const [editing, setEditing] = useState(false);

  const saveName = () => {
    put(`/users/${id}`, {onSuccess: () => setEditing(false)});
  }
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box sx={{ width: 320, display: 'flex', flexDirection: 'column', py: 3, gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2 }}>
          <Typography variant="h6">User Information</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        {editing ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 1 }}>
            <TextField
              fullWidth
              label="Name"
              variant="outlined"
              name="name"
              slotProps={{
                input: {
                  endAdornment: <Button onClick={saveName} size="small" variant="text" color="primary">SAVE</Button>
                }
              }}
              value={data.name}
              onChange={(e) => setData('name', e.target.value)}
            />
            {errors.name && <Typography variant="body1" color="error">{errors.name}</Typography>}
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, px: 2 }}>
            <Typography variant="caption" color="text.secondary">Name</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="body1">{name}</Typography>
              <IconButton sx={{ padding: 0 }} onClick={() => setEditing(true)}>
                <EditIcon />
              </IconButton>
            </Box>
          </Box>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', px: 2, gap: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="caption" color="text.secondary">Email</Typography>
            <Typography variant="body1">{email}</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="caption" color="text.secondary">Facility Name</Typography>
            <Typography variant="body1">{facility_name}</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="caption" color="text.secondary">Facility Location</Typography>
            <Typography variant="body1">{facility_location}</Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="caption" color="text.secondary">User Type</Typography>
            <Typography variant="body1">{role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</Typography>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
}